module.exports = __webpack_public_path__ + "img/technical2.db0275ba.png";